const replaceUrlToCurrentProtocol = (url) => url
    && (window.location.protocol === 'http:' || window.location.protocol === 'https:')
        ? url.replace(/https?:\/\//g, `${window.location.protocol}//`)
        : url;

export default replaceUrlToCurrentProtocol;



// WEBPACK FOOTER //
// ./src/utils/replaceUrlToCurrentProtocol.js